module.exports = __webpack_public_path__ + "4e0a7641fa4264a700eedad04255db03.svg";